// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ed9a91a","455":"1a917c2e"}[chunkId] + ".chunk.js";
};